import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const CheckList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  line-height: ${theme.font.lineHeight};
`;

export const Item = styled.li`
  display: flex;

  &.small {
    font-weight: 400;
  }

  & + & {
    margin-top: ${size(2)};
  }

  &.small + &.small {
    margin-top: ${size(1)};
  }

  ${theme.screens.Md} {
    font-size: 18px;
  }
`;

export const CheckIconContainer = styled.div`
  color: ${theme.colors.ui.positive};
  margin-right: ${size(1)};
  margin-top: 3px;
  font-size: 24px;
`;
